import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import Menu from "./Menu";
import Dashboard from "./Dashboard";
import Vehicles from "./Vehicles";
import Loader from "../reusable_components/Loader";
import TopBar from "../reusable_components/TopBar";
import { useRecoilState } from "recoil";
import myInfoAtom from "../atoms/myInfoAtom";
import loginStateAtom from "../atoms/loginStateAtom";
import navMenuStateAtom from "../atoms/navMenuState";
import { url } from "../utils/config";
import axios from "axios";
import { toast } from "react-toastify";
import patchData from "../custom_functions/patchData";
import Quotations from "./Quotations";
import globalConfigAtom from "../atoms/globalConfigAtom";
import FuelCosts from "./FuelCosts";
import Team from "./Team";
import Reminders from "./Reminders";
import Billing from "./Billing";
import Invoice from "./Invoice";
import Setting from "./Setting";
import reminderAtom from "../atoms/reminderAtom";

function Home() {
  const [loggedIn] = useRecoilState(loginStateAtom);
  const [myInfo, setMyInfo] = useRecoilState(myInfoAtom);
  const [reminders, setReminders] = useRecoilState(reminderAtom);
  const [showNavMenu, setShowNavMenu] = useRecoilState(navMenuStateAtom);
  const [globalConfig, setGlobalConfig] = useRecoilState(globalConfigAtom);
  const loggedInAs = myInfo?.loggedInAs || (typeof window !== "undefined" ? window.localStorage.getItem("loggedInAs") : null);
  const isFleetManager = loggedInAs === "fleet_manager";

  useEffect(() => {
    fetchMyInfo();
    fetchReminders();
    fetchGlobalConfig();
  }, [loggedIn]);

  useEffect(() => {
    if (showNavMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [showNavMenu]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth >= 1024) {
        setShowNavMenu(false);
      }
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setShowNavMenu]);

  async function fetchMyInfo() {
    try {
      const reqUrl = url + "/my_info";
      const token = window.localStorage.getItem("fm_token");
      const headers = { authorization: `bearer ${token}` };
      const { data } = await axios.get(reqUrl, { headers });
      setMyInfo(data.data);
      // console.log(data);
    } catch (error) {
      toast.error(error.response.data.message, { autoClose: 3000 });
    }
  }

  async function fetchReminders() {
    try {
      const reqUrl = url + "/reminders?page=1";
      const token = window.localStorage.getItem("fm_token");
      const headers = { authorization: `bearer ${token}` };
      const { data } = await axios.get(reqUrl, { headers });
      setReminders(data.data || []);
      // console.log(data);
    } catch (error) {
      toast.error(error.response.data.message, { autoClose: 3000 });
    }
  }

  async function fetchGlobalConfig() {
    try {
      const reqUrl = url + "/global_config";
      const token = window.localStorage.getItem("fm_token");
      const headers = { authorization: `bearer ${token}` };
      const { data } = await axios.get(reqUrl, { headers });
      setGlobalConfig(data.data);
      // console.log(data);
    } catch (error) {
      toast.error(error.response.data.message, { autoClose: 3000 });
    }
  }

  function handleAcknowledgeReminder(reminder, onComplete) {
    if (!reminder?.id || reminder?.isAcknowledged) {
      onComplete && onComplete();
      return;
    }
    patchData(
      `${url}/acknowledge_reminder/${reminder.id}`,
      { isAcknowledged: true },
      (error) => {
        onComplete && onComplete();
        toast.error("Unable to acknowledge", { autoClose: 3000 });
      },
      () => {
        onComplete && onComplete();
        setReminders((prev) =>
          prev.filter((item) => item.id !== reminder.id)
        );
      }
    );
  }

  return (
    <>
      <Loader />
      <div className="min-h-screen bg-neutral-50">
        <div className="hidden lg:block">
          <div className="fixed left-0 top-0 h-screen w-[280px] overflow-y-auto border-r border-neutral-200 shadow-sm bg-white">
            <Menu />
          </div>
        </div>

        <div className="flex min-h-screen flex-col lg:ml-[280px]">
          {/* Top Bar with Greeting, Notifications, and Profile */}
          <TopBar 
            onMenuClick={() => setShowNavMenu(true)} 
            reminders={reminders} 
            onAcknowledge={handleAcknowledgeReminder}
          />

          <main className="flex-1 overflow-auto px-4 pb-6 pt-4 lg:px-8 lg:py-8 bg-neutral-50">
            <Routes>
              <Route exact path='/' element={<Dashboard />} />
              <Route path='/vehicles' element={<Vehicles />} />
              <Route path='/service_requests' element={<Quotations />} />
              {/* <Route path='/fuel-costs' element={<FuelCosts />} /> */}
              <Route path='/teams' element={isFleetManager ? <Team /> : <Navigate to='/' replace />} />
              <Route path='/reminders' element={<Reminders />} />
              <Route path='/billing' element={<Billing />} />
              <Route path='/invoice' element={<Invoice />} />
              <Route path='/setting' element={<Setting />} />
            </Routes>
          </main>
        </div>
      </div>

      {showNavMenu && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-sm"
            onClick={() => setShowNavMenu(false)}
          />
          <div
            className="absolute inset-y-0 left-0 h-full w-[280px] max-w-[85%] shadow-xl bg-white overflow-y-auto"
            onClick={(event) => event.stopPropagation()}
          >
            <Menu onNavigate={() => setShowNavMenu(false)} onClose={() => setShowNavMenu(false)} />
          </div>
        </div>
      )}
    </>
  );
}

export default Home;
